const PAS_REQUEST_DRAFT_KEY = "pas_request_draft_v1";

export const savePasRequestDraft = (serviceCode, form) => {
  if (!serviceCode || !form) return;
  try {
    sessionStorage.setItem(
      PAS_REQUEST_DRAFT_KEY,
      JSON.stringify({ serviceCode, form, savedAt: Date.now() }),
    );
  } catch {
    // ignore quota / private mode
  }
};

export const readPasRequestDraft = () => {
  try {
    const raw = sessionStorage.getItem(PAS_REQUEST_DRAFT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.serviceCode || !parsed?.form) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const clearPasRequestDraft = () => {
  sessionStorage.removeItem(PAS_REQUEST_DRAFT_KEY);
};
